import { Button, Flex, Modal, TextInput } from "@mantine/core";
import { useState } from "react";
import { usePostApi } from "src/hooks";
import { useSelector } from "src/redux/hooks";
import { Notification } from "src/utils/Notification";

interface Props {
  opened: boolean;
  close: () => void;
}

const SaveFavouriteModal = ({ opened, close }: Props) => {
  const lbid = useSelector(state => state.generatorSlice.entryDataToSave.lbid);
  const lbeid = useSelector(state => state.generatorSlice.latestEntry.id);
  const [name, setName] = useState("");
  const { post, isLoading } = usePostApi();

  const handleClose = () => {
    setName("");
    close();
  };

  const handleSave = () => {
    void post({
      request: "save-favourite",
      body: { params: { lbid, lbeid, name: name.trim() } },
      onSuccess: () => {
        Notification("Favourite", "Entry saved as favourite", "green");
        handleClose();
      },
    });
  };

  return (
    <Modal opened={opened} onClose={handleClose} title="Save as Favourite">
      <TextInput
        data-autofocus
        label="Favourite name"
        placeholder="e.g. Bunkering"
        value={name}
        onChange={e => setName(e.currentTarget.value)}
        onKeyDown={e => {
          if (e.key === "Enter" && name.trim()) handleSave();
        }}
      />
      <Flex justify="flex-end" gap={10} mt={20}>
        <Button variant="default" onClick={handleClose}>
          Cancel
        </Button>
        <Button
          loading={isLoading}
          disabled={!name.trim()}
          onClick={handleSave}>
          Save
        </Button>
      </Flex>
    </Modal>
  );
};

export default SaveFavouriteModal;
